<script>

import OrderList from '@components/e-shop/order-list.vue'
import OrderUserData from '@components/e-shop/order-user-data.vue'

export default {
  components: {
    OrderList,
    OrderUserData
  },
}
</script>

<template>
  <div class="wrapper">
    <div class="content">
      <OrderList />
      <OrderUserData />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
@import '@styles/form.scss';

.content {
  display: grid;
  column-gap: 20px;
  margin-top: 30px;
  grid-template-columns: repeat(2, 1fr);
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .content {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    margin-top: 17px;
  }
}
</style>
